import {asset} from 'imba';
import url from './overview.png';
export default asset({
	url: url,
	type: 'image',
	width: 1204,
	height: 656,
	toString: function(){ return this.url;}
})